var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPayments = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "navbar-btn-svg-icon",
    x: "0px",
    y: "0px",
    width: 692.5,
    height: 427.5,
    viewBox: "0 0 110.8 68.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 60v-2.9H17.2V45.8h-2.8V60zm73.1-14.2h-2.9v11.3H87.5V60h14.2zM14.4 28.7h2.8V17.4h11.4v-2.9H14.4zm73.8-14.2v2.9h11.3v11.3h2.9V14.5zm-49 22.7c0 10.2 8.2 18.5 18.5 18.5s18.4-8.2 18.4-18.5-8.2-18.5-18.5-18.5S39.2 27 39.2 37.2zm19.9-11.3c2.3 0 4 .6 5.3 1.1l-1.1 4c-.9-.4-2.4-1-4.5-1s-3.3 1-3.3 2.1c0 1.4 1.3 2 4.1 3.1 3.8 1.4 5.7 3.4 5.7 6.5s-2 5.7-6.1 6.5v3.3h-2.8v-3.1c-2.4 0-5-.7-6.1-1.3l1-4.1c1.3.7 3.4 1.4 5.5 1.4 2.3 0 3.5-1 3.5-2.4s-1-2.1-3.7-3.1c-3.7-1.3-6.1-3.3-6.1-6.5 0-3.1 2.1-5.5 5.8-6.4v-3.4h2.8v3.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 5.9V0H0v62.5h5.8v5.9h105V5.9zM2.8 59.7V2.9h99.3v3H5.8v53.8zM108 65.6H8.7V8.7H108z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPayments, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/payments.1385d834.svg";
export { ForwardRef as ReactComponent };